import CalculationDriverSalary from "components/calculationDriverSalary";
import CalculationSalariesShow from "components/calculationSalaries/show";
import DocumentTracking from "components/documentTracking";
import { paths } from "helpers/paths";
import { paramsObject } from "helpers/system";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";
import ReportPage from "./reportPage";

const Reports = (props) => {
    const { location, history } = props;
    const back = () => history.push(paths.reports);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={paths.reportsShow("list")} render={() => <Redirect to={paths.reports} />} />
                <Route
                    path={paths.reportsShow("document-tracking")}
                    render={(rest) => <DocumentTracking {...rest} back={back} />}
                />
                <Route
                    path={paths.reportsShow("LogisticSalaryReport")}
                    render={(rest) => <CalculationSalariesShow {...rest} back={back} title="Расчет ЗП логистов" />}
                />
                <Route
                    path={paths.reportsShow("DriverSalaryReport")}
                    render={(rest) => <CalculationDriverSalary {...rest} back={back} title="Расчет ЗП водителей" />}
                />
                <Route
                    path={paths.reportsShow(":id")}
                    render={(props) => {
                        const id = props.match.params.id;
                        const { taskKey, regionId, regionType } = paramsObject(props.location.search);
                        return (
                            <ReportPage
                                {...props}
                                id={id}
                                taskKey={taskKey}
                                regionId={regionId}
                                regionType={regionType}
                                transition="full"
                                back={back}
                            />
                        );
                    }}
                />
                <Route path={paths.reports} component={List} />
            </Switch>
        </div>
    );
};

export default Reports;
